import React, { Fragment } from 'react';

// HOC
import { withUserWebView } from '@shopee-user/with-web-view';

// Components
import { Navbar, Button } from '@shopee-user/business-customization-ui';

// Utils
import { compose } from 'redux';
import { config } from '@shopee-user/platform';

// Types
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

// Constants
import { TITLE_CRASH_TEXT, TITLE_RETRY_TEXT } from './constants';

// Assets
import imgError from './img_error.png';

import styles from './style.scss';

type Props = {
  error: Error;
} & WithUserWebViewProps;

function CrashComponent({ error, webViewNavigateBack }: Props) {
  return (
    <Fragment>
      <Navbar onClickBack={() => webViewNavigateBack()} isResponsive={false} />

      <div className={styles.container}>
        <img className={styles.img} src={imgError} />
        <div className={styles.text}>{TITLE_CRASH_TEXT}</div>
        <div className={styles.retry}>
          <Button text={TITLE_RETRY_TEXT} onClick={() => location.reload()} />
        </div>
        {config.ENV !== 'live' && error && (
          <pre className={styles.pre}>{error.stack}</pre>
        )}
      </div>
    </Fragment>
  );
}

export default compose(withUserWebView({}))(CrashComponent);
